var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFieldDerived = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m6.988 10.809-1.031 4.84q-.276 1.3-1.16 2.126-.885.827-1.822.827-.516 0-.76-.197a.61.61 0 0 1-.242-.495.7.7 0 0 1 .152-.445q.152-.194.44-.194.18 0 .319.082a1 1 0 0 1 .243.206q.082.099.185.27l.178.292q.452-.034.77-.61.32-.573.554-1.64l1.079-5.062H4.75l.123-.534h1.13l.083-.398q.14-.68.445-1.225t.692-.925q.381-.375.864-.59.483-.213.929-.213.515 0 .758.196a.61.61 0 0 1 .244.495.73.73 0 0 1-.144.446q-.144.193-.448.193a.6.6 0 0 1-.317-.08.9.9 0 0 1-.24-.207 2 2 0 0 1-.187-.276 4 4 0 0 0-.176-.287q-.405.018-.715.534-.311.515-.562 1.716l-.13.621H8.57l-.123.534zm2.225 2.261c0-1.758.45-3.183 1.387-4.424h.713c-.694.89-1.236 2.774-1.236 4.424 0 1.66.537 3.54 1.236 4.429H10.6c-.938-1.24-1.387-2.666-1.387-4.429m5.288.957h-.078l-1.25 1.988h-.952l1.802-2.632L12.2 10.75h1.001l1.25 1.958h.078l1.236-1.958h.952l-1.787 2.598 1.811 2.666h-.996zm5.23-.952c0 1.758-.45 3.184-1.387 4.424h-.713c.693-.889 1.235-2.773 1.235-4.424 0-1.66-.537-3.54-1.235-4.429h.713c.937 1.24 1.386 2.666 1.386 4.43",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgFieldDerived);
export default ForwardRef;